module.exports = __webpack_public_path__ + "img/normal_multiplier.7b923fd6.png";